'use client';

import { useAuth } from '@/lib/useAuth';
import { Eye } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export function ImpersonationBanner() {
  const { user, impersonating, exitImpersonation } = useAuth();

  if (!impersonating || !user) return null;

  return (
    <div className="bg-amber-600 text-white px-4 py-2 flex items-center justify-between text-sm z-50 sticky top-0">
      <div className="flex items-center gap-2">
        <Eye className="w-4 h-4" />
        <span>
          Viewing as <strong>{user.name}</strong> ({user.role})
        </span>
      </div>
      <Button
        onClick={exitImpersonation}
        className="px-3 py-1 bg-white/20 hover:bg-white/30 rounded text-sm font-medium transition-colors"
      >
        Exit
      </Button>
    </div>
  );
}
